import { AuthGuardService } from 'src/app/auth-guard.service';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ClaimsBalanceSearchComponent } from './claims-balance-search/claims-balance-search.component';
import { ClaimsStatusSearchComponent } from './claims-status-search/claims-status-search.component';

const routes: Routes = [
  {
    path: 'search-claims-status',
    component: ClaimsStatusSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-claims-balance',
    component: ClaimsBalanceSearchComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class ClaimsRoutingModule {}
